import { GraphQLFormattedError } from "graphql";

/**
 * Handles GraphQL errors and throws with all error messages combined
 */
export const handleGraphQLErrors = (errors?: readonly GraphQLFormattedError[]) => {
  if (errors && errors.length > 0) {
    const messages = errors.map((error) => error.message).join("; ");
    throw new Error(messages);
  }
};
